import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import API_BASE_URL from "../services/apiClient";
// import BackHeader from "../components/hub/BackHeader";

const TripSharePage = ({ onTabChange }) => {

  const { travelKeyToken } = useParams();
  const [trip, setTrip] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    

    const fetchTrip = async () => {

      const token =
        sessionStorage.getItem("token") ||
        localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE_URL}/api/trips/${travelKeyToken}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await res.json();
      setTrip(data);
      setLoading(false);

    };

    fetchTrip();


  }, [travelKeyToken]);

  if (loading) {
    return (<div className="min-h-screen flex items-center justify-center">
      Loading... </div>
    );
  }

  const shareLink = `${window.location.origin}/share/${trip.shareToken}`;

  return (


    <div className="min-h-screen bg-[#fdfcf7] flex flex-col items-center p-6">

      <div className="max-w-xl w-full mb-4">
  <button
    onClick={() => window.history.back()}
    className="flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-[#5b6f00] transition"
  >
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 19l-7-7 7-7"
      />
    </svg>

    Back
  </button>
</div>

      <div className="max-w-xl w-full bg-white rounded-3xl p-10 border border-gray-100 shadow-sm space-y-8">

        <h1 className="text-3xl font-bold text-gray-900">
          Share Your trip
        </h1>

        <p className="text-gray-600 text-sm">
          Anyone with this link can view the itinerary.
          If they want, they can copy it to their own dashboard.
        </p>

        {/* SHARE LINK */}

        <div className="bg-gray-50 p-4 rounded-xl flex items-center justify-between">

          <span className="text-sm text-gray-700 break-all">
            {shareLink}
          </span>

          <button
            onClick={() => {
              navigator.clipboard.writeText(shareLink);
              alert("Link copied!");
            }}
            className="text-[#5b6f00] font-bold text-sm"
          >
            Copy
          </button>

        </div>

        {/* QR CODE */}

        <div className="flex flex-col items-center gap-4">

          <QRCodeCanvas
            value={shareLink}
            size={180}
          />

          <p className="text-xs text-gray-400">
            Scan to open instantly
          </p>

        </div>

        {/* WHATSAPP SHARE */}

        <a
          href={`https://wa.me/?text=${encodeURIComponent(
            `Check out my travel itinerary planned on Expeditio 🌍\n\n${shareLink}`
          )}`}
          target="_blank"
          rel="noreferrer"
          className="block w-full text-center bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition"
        >
          Share on WhatsApp
        </a>

        <div className="text-xs text-gray-400 text-center">
          Friends will be able to view your itinerary and save their own copy.
        </div>

      </div>

    </div>


  );
};

export default TripSharePage;
